import axios from "~/plugins/axios";

export default {
  paginate(page = 1, perPage = 15) {
    return axios.get("/web_api/v1/search", {
      params: {
        page,
        perPage,
      },
    })
      .then((response) => response.data);
  },
  paginateByModel(model, page = 1, perPage = 15) {
    return axios.post("/web_api/v1/search/by_model", { model }, {
      params: {
        page,
        perPage,
      },
    })
      .then((response) => response.data);
  },
  paginateByAutomationAction(automationAction, page = 1, perPage = 15) {
    return axios.get(`/web_api/v1/search/by_automation_action/${automationAction.id}`, {
      params: {
        page,
        perPage,
      },
    })
      .then((response) => response.data);
  },
  getSearch(searchId) {
    return this.getSearchById(searchId);
  },
  getSearchById(searchId) {
    return axios.get(`/web_api/v1/search/${searchId}`)
      .then((response) => response.data);
  },
  exportSearchToCSV(searchModel, searchContent, valuesToExport = null) {
    return axios.post("/web_api/v1/search/export/csv", {
      model: searchModel,
      content: searchContent,
      values: valuesToExport,
    })
      .then((response) => response.data.data);
  },
  getPaginatedSearchablesBySearch(searchId) {
    return axios.get(`/web_api/v1/search/${searchId}/results`)
      .then((response) => response.data);
  },
  exportStaticSearchToCSV(searchModel, searchKey, metaData, valuesToExport = null) {
    return axios.post("/web_api/v1/static_search/export/csv", {
      model: searchModel,
      searchKey,
      values: valuesToExport,
      metaData,
    })
      .then((response) => response.data.data);
  },
};
